import { html, LitElement, nothing } from 'lit';
import { repeat } from 'lit-html/directives/repeat.js'

import { WinhagerScheduleBlock } from './windhager-schedule-block';
import { localize } from './localize/localize';

export class WindhagerSchedule extends LitElement {

    // internal reactive states
    static get properties() {
        return {
            schedule: { state: false },
        };
    }

	render() {
		return html`
			<div>
				${repeat(this.schedule, item => item.weekdays,
				(item,index) => html`<windhager-schedule-block weekdays="${item.weekdays}" switchPoints="${item.switchPoints}" .parent="${this}" .index="${index}""/>`)}
			</div>
			<div>
				<mwc-button class="switchpoint-button" @click="${() => {this.parent.publish(this.getScheduleString())}}" >
					${localize('common.apply')}
				</mwc-button>
			</div>
		`;
	}

	addBlock(block) {
		this.schedule.push(block);
		this.requestUpdate();
	}

	removeDay(day) {
		for (var i=0; i < this.schedule.length; i++) {
			let j = this.schedule[i]["weekdays"].indexOf(day);
			if (j != -1) {
				// epxlicitly set to force update
				this.schedule[i]["weekdays"] = this.schedule[i]["weekdays"].toSpliced(j,1);
				if (this.schedule[i]["weekdays"].length == 0) {
					this.schedule.splice(i,1);
				}
			}
		}
		this.requestUpdate();
	}

	getScheduleString() {
		return JSON.stringify(this.schedule);
	}

}
customElements.define('windhager-schedule', WindhagerSchedule);
